import req from "../http";

const position = {
  // 依查詢條件 取得職務(分頁)
  getPositionPaging(params) {
    return req("get", "/BasicInformation/position/paging", params);
  },

  // 依職務代碼 取得職務
  getPositionInfo(guid) {
    return req("get", `/BasicInformation/position/${guid}`);
  },

  // 新增 職務
  postPosition(params) {
    return req("post", "/BasicInformation/position", params);
  },

  // 更新 職務
  putPosition(params) {
    return req("put", "/BasicInformation/position", params);
  },

  // 刪除 職務
  deletePosition(guid) {
    return req("delete", `/BasicInformation/position/${guid}`);
  },
};

export default position;